import PublicAssetTag from "src/api/graphql/__generated__/enums/PublicAssetTag";

const getTagDisplayText = (tag: PublicAssetTag): string | null => {
	switch (tag) {
		case PublicAssetTag.NightOut:
			return "Night out";
		case PublicAssetTag.Beach:
			return "Beach";
		case PublicAssetTag.Concert:
			return "Concert";
		case PublicAssetTag.Wedding:
			return "Wedding";
		case PublicAssetTag.Graduation:
			return "Graduation";
		case PublicAssetTag.Brunch:
			return "Brunch";
		case PublicAssetTag.Formals:
			return "Formals";
		case PublicAssetTag.Trip:
			return "Trip";
		case PublicAssetTag.Birthday:
			return "Birthday";
		case PublicAssetTag.Rave:
			return "Rave";
		case PublicAssetTag.Pregame:
			return "Pregame";
		case PublicAssetTag.Picnic:
			return "Picnic";
		case PublicAssetTag.BidDay:
			return "Bid day";
		case PublicAssetTag.GameDay:
			return "Game day";
		case PublicAssetTag.Fraternity:
			return "Fraternity";
		case PublicAssetTag.Sorority:
			return "Sorority";
		case PublicAssetTag.Friends:
			return "Friends";
		case PublicAssetTag.Girlies:
			return "Girlies";
		case PublicAssetTag.Test:
			return "Experimental";
		default:
			// Don't throw here; the client may get unrecognized tags from the server.
			return null;
	}
};
export default getTagDisplayText;
